import { Link, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PublicNav() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#F7F5F0]/90 backdrop-blur-md border-b border-[#E2DFD8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-9 h-9 rounded-full bg-[#2C4C3B] flex items-center justify-center">
            <Heart className="w-5 h-5 text-[#F7F5F0]" fill="currentColor" />
          </div>
          <span className="font-display text-xl font-semibold text-[#2C4C3B] tracking-tight">
            CareHome<span className="text-[#9CAF88]">Connect</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-[15px] text-[#5C6B62]">
          <Link to="/articles" className="hover:text-[#2C4C3B] transition" data-testid="nav-articles">
            Learn
          </Link>
          <Link to="/quiz" className="hover:text-[#2C4C3B] transition" data-testid="nav-quiz">
            Find care
          </Link>
          <Link to="/for-partners" className="hover:text-[#2C4C3B] transition" data-testid="nav-for-partners">
            For partners
          </Link>
          <Link to="/login" className="hover:text-[#2C4C3B] transition" data-testid="nav-login">
            Sign in
          </Link>
        </nav>
        <Button
          onClick={() => navigate("/quiz")}
          className="bg-[#2C4C3B] hover:bg-[#1A2E24] text-white rounded-xl h-10 px-5 font-medium"
          data-testid="nav-cta-quiz"
        >
          Start the quiz
        </Button>
      </div>
    </header>
  );
}
